function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.09315 8.43476L12.6287 11.9703M9.09315 11.9703L12.6287 8.43476M19.1943 10.0003C19.1943 14.6027 15.4633 18.3337 10.8609 18.3337C6.25855 18.3337 2.52759 14.6027 2.52759 10.0003C2.52759 5.39795 6.25855 1.66699 10.8609 1.66699C15.4633 1.66699 19.1943 5.39795 19.1943 10.0003Z",
    stroke: "#F6F6F6",
    style: {
      stroke: "#F6F6F6",
      stroke: "color(display-p3 0.9649 0.9649 0.9649)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.41c74f73d86bc0d1a7cd2c95a6a3278f.svg";
export { ForwardRef as ReactComponent };